/* global translations */
/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_this"] }] */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'react-bootstrap-dialog';
import cx from '../../utils/cx';
import ImageSvg from '../../components/image/ImageSvg';
import SearchParamsStore from '../../stores/SearchParamsStore';
import PermissionsStore from '../../stores/PermissionsStore';
import MemberStore from '../../stores/MemberStore';

class SearchTopContainer extends Component {
  state = {
    params: SearchParamsStore.getSearchParams(),
    tags: SearchParamsStore.getTags(),
    currentPermission: PermissionsStore.get('geolocation'),
  };

  constructor(props) {
    super(props);

    SearchParamsStore.addChangeQueryListener(this.onQueryChange);
    MemberStore.addChangeQuestionListener(this.onQuestionChange);

    this.showDialog = this.showDialog.bind(this);
    Dialog.setOptions({
      defaultOkLabel: translations['txt: Jā'],
      defaultCancelLabel: translations['txt: Atcelt'],
    });

    const { params } = this.state;
    if (typeof params.order !== 'undefined' && params.order === 'closest') {
      MemberStore.setShowDistance(true);
    }
  }

  componentWillUnmount() {
    SearchParamsStore.removeChangeQueryListener(this.onQueryChange);

    MemberStore.removeChangeQuestionListener(this.onQuestionChange);
  }

  onQueryChange = () => {
    this.setState({
      tags: SearchParamsStore.getTags(),
      params: SearchParamsStore.getSearchParams(),
    });
  };

  onQuestionChange = () => {
    this.setState({ tags: SearchParamsStore.getTags() });
  };

  removeTag = (key, val) => {
    SearchParamsStore.setDefaultVal(key, val);
  };

  showDialog = (msg, callback) => {
    this.dialog.show({
      body: msg,
      actions: [
        Dialog.CancelAction(), // eslint-disable-line babel/new-cap
        Dialog.OKAction(callback), // eslint-disable-line babel/new-cap
      ],
    });
  };

  closestOrder = (e) => {
    if (this.state.currentPermission === 1) {
      this.changeOrder('closest');
      return;
    }

    let msg = '';
    if (typeof e !== 'undefined') {
      msg = e.target.getAttribute('data-confirm-msg');
    }

    const _this = this;
    const callback = (result) => { // eslint-disable-line vars-on-top
      if (result) {
        const prevPermission = PermissionsStore.get('geolocation'); // eslint-disable-line vars-on-top
        _this.savePosition(() => {
          this.setState({
            currentPermission: 1,
          });
          this.changeOrder('closest');
        }, () => {
          if (prevPermission !== 0) {
            PermissionsStore.showInstructions('geolocation');
          }
        });
      }
    };

    if (this.state.currentPermission !== 0) {
      PermissionsStore.showInstructions('geolocation');
      return;
    }

    this.showDialog(msg, callback);
  };

  savePosition = (successCallback, errCallback) => {
    const error = () => {
      PermissionsStore.set('geolocation', 2);
      if (errCallback) {
        errCallback();
      }
    };

    const success = (position) => {
      fetch('/apiv1/locations/save', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          source: 'geolocation',
        }),
      })
        .then((resp) => resp.json())
        .then((data) => { // eslint-disable-line no-shadow
          if (data.status !== 'ok') {
            error();
            return;
          }
          //
          if (successCallback) {
            successCallback();
          }
          PermissionsStore.set('geolocation', 1);
          // PermissionsStore.emitChange();
        })
        .catch((data) => { // eslint-disable-line no-shadow
          console.log(data);
          // window.location.reload(true);
          // TODO vajadzētu izvadīt kļūdu paziņojumu
        });
    };

    if (!navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition(success, error);
  };

  changeOrder = (val) => {
    SearchParamsStore.setSearchParam('order', val);
    if (val === 'closest') {
      MemberStore.setShowDistance(true);
      return;
    }
    MemberStore.setShowDistance(false);
  };

  render() {
    const { tags, params } = this.state;
    const { extended, changeExtended, resetCache } = this.props;

    const renderTags = () => {
      const readyTags = [];
      Object.entries(tags).forEach((tag) => {
        readyTags.push( // eslint-disable-line function-paren-newline
          <span
            key={tag[0]}
            role="presentation"
            className="searchTags-item"
            onClick={() => this.removeTag(tag[1].key, tag[1].value)}
          >
            <span>{tag[1].title}</span>
            <ImageSvg svg="icon-close" iconClass="icon mlxs icon--close" />
          </span>,
        ); // eslint-disable-line function-paren-newline
      });

      return (
        <div className="searchTags">{readyTags}</div>
      );
    };

    return (
      <div className="contentHeader">
        <div>
          <div className="mbs searchTop">
            <div
              className={cx([
                'btn btn--transparent btn--small btn--iconLeft',
                ['active', typeof params.order === 'undefined' || params.order === 'last_action'],
              ])}
              onClick={() => this.changeOrder('last_action')}
              role="presentation"
            >
              <span>{translations['txt: Online']}</span>
              <span className="btn-static">
                <span className="vcenter">
                  <span className="vcenter-inner">
                    <span className="icon icon--online" />
                  </span>
                </span>
              </span>
            </div>
            <div
              className={cx([
                'btn btn--transparent btn--small',
                ['active', typeof params.order !== 'undefined' && params.order === 'created'],
              ])}
              data-target="#content"
              onClick={() => this.changeOrder('created')}
              role="presentation"
            >
              {translations['txt: Jaunākās']}
            </div>
            <div
              data-confirm-msg="Lai atlasītu Tuvākos lietotājus, nepieciešama tava atļauja izmantot geolokācijas datus. Vai ļausi otrapuse.lv noteikt savu atrašanās vietu?"
              className={cx([
                'btn btn--transparent search-closest btn--small',
                ['active', typeof params.order !== 'undefined' && params.order === 'closest'],
              ])}
              data-target="#content"
              onClick={(e) => { this.closestOrder(e); }}
              role="presentation"
            >
              {translations['txt: Tuvākie']}
            </div>

            <div
              className="btn btn--oneIcon tooltip"
              data-tooltip={translations['txt: (atjaunot rezultātus)']}
              onClick={() => resetCache()}
              role="presentation"
              data-target="#content"
            >
              <span className="btn-static">
                <span className="vcenter">
                  <span className="vcenter-inner">
                    <ImageSvg svg="icon-reload" iconClass="icon icon--reload" />
                  </span>
                </span>
              </span>
            </div>

            <div className="fr">
              <div
                className={cx([
                  'btn btn--oneIcon',
                  ['btn--d', extended],
                  ['btn--b', !extended],
                ])}
                onClick={() => changeExtended(false)}
                role="presentation"
              >
                <span className="btn-static">
                  <span className="vcenter">
                    <span className="vcenter-inner">
                      <ImageSvg svg="icon-grid-2" iconClass="icon icon--grid-2" />
                    </span>
                  </span>
                </span>
              </div>
              <div
                className={cx([
                  'btn btn--oneIcon',
                  ['btn--b', extended],
                  ['btn--d', !extended],
                ])}
                onClick={() => changeExtended(true)}
                role="presentation"
              >
                <span className="btn-static">
                  <span className="vcenter">
                    <span className="vcenter-inner">
                      <ImageSvg svg="icon-grid-1" iconClass="icon icon--grid-1" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          {renderTags()}
        </div>
        <Dialog ref={(el) => { this.dialog = el; }} />
      </div>
    );
  }
}

SearchTopContainer.propTypes = {
  changeExtended: PropTypes.func,
  extended: PropTypes.bool,
  resetCache: PropTypes.func,
};

SearchTopContainer.defaultProps = {
  changeExtended: null,
  extended: false,
  resetCache: null,
};

export default SearchTopContainer;
